import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import PropTypes from 'prop-types';

function ForumLeftContent({ setActiveFilter }) {
  const [activeMenu, setActiveMenu] = useState('home');
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Sync menu state with URL on mount and location changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const filter = params.get('filter') || 'home';
    setActiveMenu(filter);
    if (typeof setActiveFilter === 'function') {
      setActiveFilter(filter);
    }
  }, [location, setActiveFilter]);

  const handleMenuClick = (filter) => {
    if (!user) {
      navigate('/signin');
      return;
    }
    setActiveMenu(filter);
    setActiveFilter(filter);
    
    // Always navigate to the community/forum route with the appropriate filter
    navigate(`/community/forum?filter=${filter}`);
  };

  return (
    <div className="w-full md:w-60 mb-8 md:mb-0">
      <div className="md:sticky md:top-16 md:h-[calc(100dvh-64px)] md:overflow-x-hidden md:overflow-y-auto no-scrollbar">
        <div className="md:py-8">
          

          <div className="flex flex-nowrap overflow-x-scroll no-scrollbar md:block md:overflow-auto px-4 md:space-y-3 -mx-4">
            <div>
              <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-3 md:sr-only">Menu</div>
              <ul className="flex flex-nowrap md:block mr-3 md:mr-0">
                <li className="mr-0.5 md:mr-0 md:mb-0.5">
                  <button 
                    onClick={() => handleMenuClick('home')}
                    className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap w-full text-left ${
                      activeMenu === 'home' ? 'bg-white dark:bg-gray-800' : ''
                    }`}
                  >
                    <svg className={`shrink-0 fill-current mr-2 ${
                      activeMenu === 'home' ? 'text-violet-500' : 'text-gray-400 dark:text-gray-500'
                    }`} width="16" height="16" viewBox="0 0 16 16">
                      <path d="M12.311 9.527c-1.161-.393-1.85-.825-2.143-1.175A3.991 3.991 0 0012 5V4c0-2.206-1.794-4-4-4S4 1.794 4 4v1c0 1.406.732 2.639 1.832 3.352-.292.35-.981.782-2.142 1.175A3.942 3.942 0 001 13.26V16h14v-2.74c0-1.69-1.081-3.19-2.689-3.733zM6 4c0-1.103.897-2 2-2s2 .897 2 2v1c0 1.103-.897 2-2 2s-2-.897-2-2V4zm7 10H3v-.74c0-.831.534-1.569 1.33-1.838 1.845-.624 3-1.436 3.452-2.422h.436c.452.986 1.607 1.798 3.453 2.422A1.943 1.943 0 0113 13.26V14z" />
                    </svg>
                    <span className={`text-sm font-medium ${
                      activeMenu === 'home' ? 'text-violet-500' : 'text-gray-600 dark:text-gray-300'
                    }`}>Hjem</span>
                  </button>
                </li>
                <li className="mr-0.5 md:mr-0 md:mb-0.5">
                  <button
                    onClick={() => handleMenuClick('liked')}
                    className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap w-full text-left ${
                      activeMenu === 'liked' ? 'bg-white dark:bg-gray-800' : ''
                    }`}
                  >
                    <svg className={`shrink-0 fill-current mr-2 ${
                      activeMenu === 'liked' ? 'text-violet-500' : 'text-gray-400 dark:text-gray-500'
                    }`} width="16" height="16" viewBox="0 0 16 16">
                      <path d="M14.682 2.318A4.485 4.485 0 0011.5 1 4.377 4.377 0 008 2.707 4.383 4.383 0 004.5 1a4.5 4.5 0 00-3.182 7.682L8 15l6.682-6.318a4.5 4.5 0 000-6.364z"/>
                    </svg>
                    <span className={`text-sm font-medium ${
                      activeMenu === 'liked' ? 'text-violet-500' : 'text-gray-600 dark:text-gray-300'
                    }`}>Indlæg du syntes om</span>
                  </button>
                </li>
                <li className="mr-0.5 md:mr-0 md:mb-0.5">
                  <button
                    onClick={() => handleMenuClick('my-posts')}
                    className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap w-full text-left ${
                      activeMenu === 'my-posts' ? 'bg-white dark:bg-gray-800' : ''
                    }`}
                  >
                    <svg className={`shrink-0 fill-current mr-2 ${
                      activeMenu === 'my-posts' ? 'text-violet-500' : 'text-gray-400 dark:text-gray-500'
                    }`} width="16" height="16" viewBox="0 0 16 16">
                      <path d="M15 4h-4V2a2 2 0 00-2-2H7a2 2 0 00-2 2v2H1a1 1 0 000 2h1v7a3 3 0 003 3h6a3 3 0 003-3V6h1a1 1 0 100-2zm-3 9a1 1 0 01-1 1H5a1 1 0 01-1-1V6h8v7zm-7-9V2h4v2H5z"/>
                    </svg>
                    <span className={`text-sm font-medium ${
                      activeMenu === 'my-posts' ? 'text-violet-500' : 'text-gray-600 dark:text-gray-300'
                    }`}>Mine indlæg</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ForumLeftContent.propTypes = {
  setActiveFilter: PropTypes.func.isRequired
};

export default ForumLeftContent;